module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-frame-open-close"
  }, [_c('div', {
    staticClass: "content-frame-open-close-top",
    style: (_vm.colorComponent()),
    on: {
      "click": _vm.openClose
    }
  }, [_c('div', {
    staticClass: "content-frame-open-close-top-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "content-frame-open-close-top-button",
    class: {
      open: _vm.openDialog, close: !_vm.openDialog
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openDialog),
      expression: "openDialog"
    }],
    staticClass: "content-frame-open-close-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5277c24b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/config/FrameOpenClose.vue
// module id = 3184
// module chunks = 0